import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class ShowAllElements extends Component {
  state = {
    rowTables: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rowTables = [];
    let recCount = 0;
    const rootElement = this.props.node;
    if (rootElement) {
      if (rootElement && rootElement.length > 0) {
        _.forEach(rootElement, (record, index) => {
          const recs = [];
          getAllRows(
            record,
            recs,
            props,
            _.get(record, "$.display"),
            0,
            undefined,
            true
          );
          if (recs.length > 0) {
            rowTables.push(
              <Table.Row key={`${props.sectionName}_${index}`}>
                <Table.Cell>
                  <Table>
                    <Table.Body>
                      <Table.Row>
                        <Table.HeaderCell
                          colSpan={2}
                          className="report-sub-section-header"
                        >
                          Record
                        </Table.HeaderCell>
                      </Table.Row>
                      {recs}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          }
        });
        recCount = rowTables.length;
      } else {
        rowTables.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rowTables.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rowTables });
    if(props.updateItemCountBySection)
      props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={this.props.sectionTitle}
        rows={this.state.rowTables}
      />
    );
  }
}

export default ShowAllElements;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/ShowAllElements.js